// extracted by mini-css-extract-plugin
module.exports = {"partnerWrap":"Partners_partnerWrap_1i7Pl","topImgs":"Partners_topImgs_1JtBE","companyImgs":"Partners_companyImgs_2qiP9"};